import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useTranslate from 'hooks/useTranslate';

const BackBtn: React.FC = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();

	const handleBackClick = () => {
		navigate(-1);
	};

	return (
		<div>
			<Link to="" onClick={handleBackClick} className="back-link position-absolute fw-semibold">
				<i className="ri-arrow-left-s-line"></i> {translate('Common.back')}
			</Link>
		</div>
	);
};
export default BackBtn;
